import { createContext, useContext } from 'react'

export const InvitePatientContext = createContext<any>({})

export const useInvitePatientContext = () => {
  const context = useContext(InvitePatientContext)
  return context
}
